import Box from "@mui/material/Box";
import {ReactNode, useState} from "react";
import {useSelector} from 'react-redux';
import {selectHintsSet} from '@/features/Auth/CurrentUser/Slice/CurrentUserSlice';
import {useGetHintByAliasQuery} from '@/api/ReferenceBooks/Hints/GetByAlias/GetHintByAliasApiSlice';
import {HintViewData} from './HintView';
import HintView from './HintView';

export interface HintProps {
    alias: string,
    top?: string,
    left?: string,
    bottom?: string,
    right?: string,
    align?: "topRight" | "topLeft" | "bottomLeft" | "bottomRight",
    width?: string,
    height?: string,
    fontSize?: string,
    forceShow?: boolean,
    inline?: boolean,
    iconColor?: string,
    children?: ReactNode,
}

function Hint(
    {
        alias,
        top,
        left,
        bottom,
        right,
        align = "topRight",
        width,
        height,
        fontSize = "1rem",
        forceShow = false,
        inline = false,
      iconColor = "black",
      children
  }: HintProps) {
    const hintsSet = useSelector(selectHintsSet);
    const hasHint = hintsSet.has(alias);
    const showHint = forceShow || hasHint;

    const [open, setOpen] = useState(false);

    const {data: hintData, isLoading} = useGetHintByAliasQuery(alias, {skip: !open});

    if (!showHint) {
        return <Box>{children}</Box>;
    }

    const hint: HintViewData | null = hintData?.data
        ? {
            title: hintData.data.title,
            content: hintData.data.content,
            location_description: hintData.data.location_description ?? null,
        }
        : null;

    return (
        <HintView
            hint={hint}
            loading={open && isLoading}
            open={open}
            onOpenChange={setOpen}
            top={top}
            left={left}
            bottom={bottom}
            right={right}
            align={align}
            width={width}
            height={height}
            fontSize={fontSize}
        >
            {children}
        </HintView>
    );
}

export default Hint;
